module.exports = __webpack_public_path__ + "img/1.8f8623c7.png";